import * as React from "react";

import {
    Grid, GridColumn as Column,
    GridSelectionChangeEvent,
    GridFilterChangeEvent,
 } from '@progress/kendo-react-grid';
import {
    filterBy,
    CompositeFilterDescriptor,
} from "@progress/kendo-data-query";

import { Loader } from "@progress/kendo-react-indicators";

import { useGetProductsQuery } from '../../store/sunbright-api';

export interface ProductsSummaryProps {
    onSelected: any;
    vaccineOnly: boolean;
}
interface ProductSummaryRow {
    uid: number;
    category?: string;
    cdmvcode?: string;
    supplier?: string;
    description?: string;
    unitsperbox?: number;
}

const DATA_ITEM_KEY = 'uid';

const initialFilter: CompositeFilterDescriptor = {
    logic: "and",
    filters: []
};

const ProductsSummary = ({
    onSelected,
    vaccineOnly
}: ProductsSummaryProps) => {

    const { data: products, error: productsError, isLoading: productsLoading } = useGetProductsQuery(vaccineOnly ? "-13" : "0");

    const [gridHeight, setGridHeight] = React.useState<string>("570px");
    const [filterState, setFilterState] = React.useState(initialFilter);

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
        setGridHeight((window.innerHeight - 380) + "px");
    }, []);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 380) + "px");
    };

    const handleFilterChange = (event: GridFilterChangeEvent) => {
        setFilterState(event.filter);
   }

    const handleGridSelectionChange = (event: GridSelectionChangeEvent) => {
        onSelected(event.startDataItem);
    }

    return (
        <React.Fragment>
            {!products ? (<Loader size="large" type="converging-spinner" />) : 
                (<div>
                    <Grid
                        style={{ height: gridHeight }}
                        className="productsGrid"
                        dataItemKey={DATA_ITEM_KEY}
                        pageable={false}
                        data={filterBy(products, filterState)}
                        filterable={true}
                        filter={filterState}
                        onFilterChange={handleFilterChange}
                        resizable={true}
                        selectable={{
                            enabled: true,
                            mode: 'single'
                        }}
                        onSelectionChange={handleGridSelectionChange}
                    >
                        <Column field="uid" filterable={false} title="Product ID" width="0px" />
                        <Column field="category" title="Category" width="174px" />
                        <Column field="cdmvcode" title="CDMV Code" width="156px" />
                        <Column field="supplier" title="Supplier" width="236px" />
                        <Column field="description" title="Description" />
                        {vaccineOnly && <Column field="species" title="Species" filterable={false} width="66px" />}
                        {vaccineOnly && <Column field="type" title="Type" filterable={false} width="114px" />}
                       <Column field="unitsperbox" title="Units per Box" filterable={false} width="108px" />
                    </Grid>
                </div>)
            }
    </React.Fragment>
    );
};
export default ProductsSummary;
